const openStatuses = ["Pending", "Partial Paid"];
const pad = value => String(value).padStart(2, "0");
const shift = (now, days) => {
  const date = new Date(now.getFullYear(), now.getMonth(), now.getDate() + days);
  return date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate());
};

export const presetFilterKeys = ["statuses", "due_date_from", "due_date_to"];

export function presetFilters(rule, now = new Date()) {
  switch (rule?.selection) {
    case "oldest_overdue": return { statuses: openStatuses, due_date_to: shift(now, -1) };
    case "next_due": return { statuses: openStatuses, due_date_from: shift(now, 0) };
    case "oldest_pending": return { statuses: openStatuses };
    case "due_date_offset": {
      const days = Number(rule.days_offset);
      const date = shift(now, -days);
      if (rule.comparison === "at_least" && days !== 0) return { statuses: openStatuses, ...(days > 0 ? { due_date_to: date } : { due_date_from: date }) };
      return { statuses: openStatuses, due_date_from: date, due_date_to: date };
    }
    default: return {};
  }
}

export function applyPreset(filters = {}, rule, now = new Date()) {
  const { statuses, due_date_from, due_date_to, ...rest } = filters;
  return { ...rest, ...presetFilters(rule, now) };
}
